import React from 'react'
import { useField } from 'formik'

import { WithInputFieldProps, InputFieldProps } from './interface'

const withInputField = (Component: React.FC<InputFieldProps>) => {
  function WithInputField({
    name,
    onChange,
    autoTrim = true,
    ...props
  }: WithInputFieldProps) {
    const [field, meta, { setValue }] = useField(name)

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      field.onChange(e)

      if (onChange) {
        onChange(e)
      }
    }

    function handleBlur(event: React.FocusEvent<HTMLInputElement>) {
      if (props.onBlur) {
        props.onBlur(event)
      }
      if (autoTrim) {
        const { value } = event.target
        setValue(value.trim())
      }
      field.onBlur(event)
    }

    const componentsProps = {
      ...props,
      ...field,
      value: field.value || '',
      error: meta.error,
      touched: meta.touched,
      onChange: handleChange,
      onBlur: handleBlur,
    }

    return <Component {...componentsProps} />
  }

  WithInputField.defaultProps = {
    type: 'text',
  }

  return WithInputField
}

export { withInputField }
